export const freeTextFormProps = {
    color: "secondary",
    fullWidth: true,
    InputLabelProps: { shrink: true },
    size: "small",
    variant: "standard",
};
